/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  var pay = function pay() {
    console.log(document.getElementById('agree').checked);

    if (document.getElementById('agree').checked == false) {
      $f7.dialog.alert("You can pay only when you agree with term and condition");
      return;
    }

    if ($("#PayLot").val() > 100 || $("#PayLot").val() <= 0) {
      $f7.dialog.alert("Please enter correct amount of Lots in between 0.01 to 100");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.path + 'static/api/bill.php?action=create',
      data: {
        Name: localStorage.getItem("Name"),
        Phone: localStorage.getItem("Phone"),
        Email: localStorage.getItem("Email"),
        Amount: $("#PayAmount").val(),
        AmountUSD: $("#PayAmountUSD").val(),
        Lots: $("#PayLot").val(),
        AccountNumber: localStorage.getItem("AccountNumber")
      },
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data); //console.log(data[0].BillCode);
        //window.open("https://toyyibpay.com/" + data[0].BillCode, '_self');

        window.open("https://robotfx.co/static/api/bill_pay.php?billcode=" + window.btoa(data[0].BillCode), '_self');
      },
      error: function error(e) {
        $f7.dialog.alert(e);
      }
    });
  };

  $on('pageInit', function () {
    $("#PayAccountNumber").val(localStorage.getItem("AccountNumber"));
    $("#PayName").val(localStorage.getItem("Name"));
    $("#PayPhone").val(localStorage.getItem("Phone"));
    $("#PayEmail").val(localStorage.getItem("Email"));
    $("#PayAmount").val((localStorage.getItem("account-stock-price") * $("#PayLot").val() * window.rate).toFixed(2));
    $("#PayAmountUSD").val((localStorage.getItem("account-stock-price") * $("#PayLot").val()).toFixed(2));
    $("#PayLot").on('change keydown paste input', function () {
      //console.log("something" + window.rate);
      $("#PayAmount").val((localStorage.getItem("account-stock-price") * $("#PayLot").val() * window.rate).toFixed(2));
      $("#PayAmountUSD").val((localStorage.getItem("account-stock-price") * $("#PayLot").val()).toFixed(2));
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Deposit</div>
    </div>
  </div>
  <div class="page-content" style="background: linear-gradient(45deg, #121212 0%, #121212 100%);">
  <div class="control-size">
    <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
      <div class="card-header">
        <div class="row">
          <div class="col-20"><img src="static/images/warning.png" style="width: 100%"/></div>
          <div class="col-80">Notice</div>
        </div>
      </div>
      <div class="card-content card-content-padding">
        <ul>
          <li>Deposit to <span class="makeitbold">Octa Markets Ltd</span>.</li>
          <li>RobotFX only automate the trade</li>
          <li>Forex trading is risky</li>
        </ul>
      </div>
      <div class="card-footer">
        <div>
          <label class="radio"><input type="radio" id="agree"/><i class="icon-radio"></i></label><span style="margin-left: 5px;">  I agree to the <a href="https://robotfx.org/terms-of-service/" class="external link"> Terms & Condition </a></span>
        </div>
        
      </div>
    </div>



    <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
      <!-- <div class="card-header">Trade
      </div> -->
      <div class="card-content card-content-padding">
        <div class="list no-hairlines-md">
          <ul>
            <li style="display: none;">
              <div class="item-content item-input" >
                <div class="item-inner">
                  <div class="item-title item-label">Name</div>
                  <div class="item-input-wrap">
                    <input type="text"  id='PayName' placeholder="Your name" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li style="display: none;">
              <div class="item-content item-input" >
                <div class="item-inner">
                  <div class="item-title item-label">Account Number</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayAccountNumber' placeholder="Account Number From Broker" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li style="display: none;">
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">E-mail</div>
                  <div class="item-input-wrap">
                    <input type="email" id='PayEmail' placeholder="E-mail" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li style="display: none;">
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Phone</div>
                  <div class="item-input-wrap">
                    <input type="tel" id='PayPhone' placeholder="Phone" disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Total Lot (0.01 to 100)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayLot' placeholder="0.01 to 100" value="0.01"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Amount To Pay (USD)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayAmountUSD' disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Amount To Pay (MYR)</div>
                  <div class="item-input-wrap">
                    <input type="number" id='PayAmount' disabled style="color: gray;"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <button class="button button-fill" @click="${pay}">PAY</button>
    </div>

  </div>  
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '62ab9d83ef';
export default framework7Component;